// src/features/users/components/RoleChip.tsx

import { Chip } from '@mui/material';
import { useTranslate } from 'react-admin';
import {
  AdminPanelSettings,
  Business,
  Hotel,
  RoomService,
  Visibility,
} from '@mui/icons-material';
import type { UserRole } from '../types';

interface RoleChipProps {
  role: UserRole;
  size?: 'small' | 'medium';
}

/**
 * Chip component to display user role with color coding
 */
export const RoleChip: React.FC<RoleChipProps> = ({ role, size = 'small' }) => {
  const translate = useTranslate();

  const roleConfig = {
    SuperAdmin: {
      color: 'error' as const,
      icon: <AdminPanelSettings fontSize="small" />,
      label: translate('resources.users.roles.superAdmin'),
    },
    Admin: {
      color: 'info' as const,
      icon: <AdminPanelSettings fontSize="small" />,
      label: translate('resources.users.roles.admin'),
    },
    GroupAdmin: {
      color: 'primary' as const,
      icon: <Business fontSize="small" />,
      label: translate('resources.users.roles.groupAdmin'),
    },
    HotelAdmin: {
      color: 'secondary' as const,
      icon: <Hotel fontSize="small" />,
      label: translate('resources.users.roles.hotelAdmin'),
    },
    Receptionist: {
      color: 'default' as const,
      icon: <RoomService fontSize="small" />,
      label: translate('resources.users.roles.receptionist'),
    },
    Viewer: {
      color: 'default' as const,
      icon: <Visibility fontSize="small" />,
      label: translate('resources.users.roles.viewer'),
    },
  };

  const config = roleConfig[role] || roleConfig.Viewer;

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      icon={config.icon}
      variant="outlined"
    />
  );
};